import ApolloClient from 'apollo-boost'

const client = new ApolloClient({
    // uri: process.env.NODE_ENV === 'production' ? 'https://aimsapi.dsmedia.ca/graphql' : 'http://localhost:4000/graphql',
    uri: 'https://aimsapi.dsmedia.ca/graphql',
    request: (operation) => {
        const accessToken = localStorage.getItem('accessToken')
        const headers = {}
        if (accessToken) headers.Authorization = `Bearer ${accessToken}`
        operation.setContext({
            headers
        })
    },
    onError: ({ graphQLErrors, networkError }) => {
        console.log('GQL',graphQLErrors)
        if (networkError) {
            if (networkError.statusCode === 401) {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('isAuthenticated')

                client.resetStore()
            }
        }
    }
  });

// const client = new ApolloClient({
//     uri: process.env.NODE_ENV === 'production' ? 'https://aimsapi.msdmsi.com' : 'http://localhost:4000',
//     request: (operation) => {
//         const accessToken = localStorage.getItem('accessToken')
//         const headers = {}
//         if (accessToken) headers.Authorization = `Bearer ${accessToken}`
//         operation.setContext({
//             headers
//         })
//     },
//     onError: ({ graphQLErrors, networkError }) => {
//         if (networkError) {
//             if (networkError.statusCode === 401) {
//                 localStorage.removeItem('accessToken')
//                 localStorage.removeItem('refreshToken')
//                 localStorage.removeItem('isAuthenticated')

//                 client.resetStore()
//             }
//         }
//     }
// })

export default client